<template functional>
  <v-list :key="data.key" two-line>
    <v-list-tile
      @click="listeners.click"
      :disabled="!props.isFileCompleted"
    >
      <v-list-tile-content>
        <v-list-tile-title>
          <v-layout row>
            <v-layout align-start>{{ props.file.filename }}</v-layout>
              <v-layout align-end justify-end>
                <v-icon
                  v-if="props.isFileCompleted"
                  :disabled="!props.isFileCompleted"
                  @click="listeners.click"
                  color="success"
                >check</v-icon>
                <v-progress-circular
                  :width="2"
                  :size="18"
                  color="primary"
                  v-else indeterminate></v-progress-circular>
              </v-layout>
          </v-layout>
        </v-list-tile-title>

        <v-list-tile-sub-title>
          <v-progress-linear
            :value="props.file.progress"
            :color="'success'"
            ></v-progress-linear>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
    <slot></slot>
  </v-list>
</template>

<script>
export default {
  name: 'nx-file-upload-list-item',
  props: {
    file: {
      type: Object,
      required: true,
    },
    isFileCompleted: {
      type: Boolean,
      required: true,
    },
  },
};
</script>
